// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--g2Sai";
export var grid = "styles-module--grid--fudgG";
export var header = "styles-module--header--KDsQv";
export var heading = "styles-module--heading--QxdZZ";
export var body = "styles-module--body--DvQ-w";
export var image = "styles-module--image--3ycPX";